import {Grid} from 'platform/foundation';

import {use} from 'react';

import {CHART_SUMMARY_COLUMNS} from '../../constants/CHART_SUMMARY_COLUMNS';
import {ChartCardContext} from '../../contexts/ChartCardContext';
import {ChartSummaryCard} from '../ChartSummaryCard/ChartSummaryCard';

interface ChartSummaryCardItem {
  id: string;
  label: string;
  /** Formatted summary value, for example a total for the selected period. */
  value: string;
  /** Formatted rate shown in a flag after the value, for example its share of the total. */
  rate?: string;
}

interface ChartSummaryCardsProps {
  items: ChartSummaryCardItem[];
}

/**
 * Summary values of a chart that has nothing to show or hide, on grey cards. A chart whose
 * series can be switched uses `ChartSummaryToggles` instead.
 */
export function ChartSummaryCards(props: ChartSummaryCardsProps) {
  const cardWidth = use(ChartCardContext)?.width ?? 'full';

  return (
    <Grid columns={CHART_SUMMARY_COLUMNS[cardWidth]} spacing={4}>
      {props.items.map((item) => (
        <ChartSummaryCard key={item.id} label={item.label} value={item.value} rate={item.rate} />
      ))}
    </Grid>
  );
}
